/**
 * @generated SignedSource<<472109dcd89fb6f3331cb8d467952bc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationFormSelector_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationContactDetails_viewer" | "SellerApplicationFormConsignorsDetails_viewer" | "SellerApplicationFormConsignorsItemUpload_viewer" | "SellerApplicationFormInventorySample_viewer">;
  readonly " $fragmentType": "SellerApplicationFormSelector_viewer";
};
export type SellerApplicationFormSelector_viewer$key = {
  readonly " $data"?: SellerApplicationFormSelector_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationFormSelector_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerApplicationFormSelector_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationContactDetails_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationFormInventorySample_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationFormConsignorsDetails_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationFormConsignorsItemUpload_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bd3c93adf5710bb797e455c1b05ead73";

export default node;
